import { DiagramObjectModel } from "../BlockDiagram";

export class DiagramPublisher {

    /**
     * Returns the published diagram in text form.
     * @param diagram
     *  The diagram to publish.
     * @returns
     *  The published diagram in text form.
     */
    public publish(diagram: DiagramObjectModel): string {
        return "";
    };

}
